(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };

      this.handleDocumentClick = this.handleDocumentClick.bind(this);
      this.elements.button.addEventListener('click', this.togglePanel.bind(this));
      this.addEventListener('keydown', this.onEscapePress.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    connectedCallback() {
      document.addEventListener('click', this.handleDocumentClick);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.handleDocumentClick);
    }

    handleDocumentClick(event) {
      if (!this.contains(event.target)) {
        this.hidePanel();
      }
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    showPanel() {
      this.elements.button.setAttribute('aria-expanded', 'true');
      this.elements.panel.removeAttribute('hidden');
    }

    togglePanel() {
      if (this.elements.button.getAttribute('aria-expanded') === 'true') {
        this.hidePanel();
      } else {
        this.showPanel();
      }
    }

    onEscapePress(event) {
      if (event.key === 'Escape') {
        this.hidePanel();
      }
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      const form = this.querySelector('form');
      const languageCode = event.currentTarget.dataset.languageCode?.trim();
      if (this.elements.input.name === 'country_code' && languageCode) {
        let languageInput = form.querySelector('input[name="language_code"]');
        if (!languageInput) {
          languageInput = document.createElement('input');
          languageInput.type = 'hidden';
          languageInput.name = 'language_code';
          form.appendChild(languageInput);
        }
        languageInput.value = languageCode;
      }
      form?.submit();
      this.hidePanel();
    }
  }

  if (!customElements.get('localization-form')) {
    customElements.define('localization-form', LocalizationForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
	class StickyHeader extends HTMLElement {
		constructor() {
			super();
		}

		connectedCallback() {
			this.header = document.querySelector('.shopify-section-header');
			this.headerOverlay = document.querySelector('.header-overlay');
			this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
			this.headerBounds = {};
			this.currentScrollTop = 0;
			this.preventReveal = false;

			if (this.headerIsAlwaysSticky) {
  this.header.classList.add('always-fixed');

  if (!this.headerOverlay) {
    this.header.classList.add('shopify-section-header-sticky');
  }

  if (this.headerOverlay) {
    this.headerOverlay.classList.add('color-background-1');
    this.headerOverlay.classList.remove('color-inverse');
  }
}

			this.onScrollHandler = this.onScroll.bind(this);
			this.hideHeaderOnScrollUp = () => this.preventReveal = true;
			this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
			window.addEventListener('scroll', this.onScrollHandler, false);

			this.createObserver();
		}

		disconnectedCallback() {
			this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
			window.removeEventListener('scroll', this.onScrollHandler);
		}

		createObserver() {
			let observer = new IntersectionObserver((entries, observer) => {
				this.headerBounds = entries[0].intersectionRect;
				observer.disconnect();
			});

			observer.observe(this.header);
		}

		onScroll() {
			const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
			if (this.hasAttribute('data-collection-sticky') && window.matchMedia('(max-width: 989px)').matches) {
				this.currentScrollTop = scrollTop;
				return;
			}

			if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
				this.header.classList.add('shopify-section-header-sticky','shopify-section-header-always-sticky');
				this.header.style.transform = 'translateY(-100%)';
			};

			if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 2) {
				this.header.classList.remove('color-background-2');
				this.header.style.transition = 'background var(--duration-short)';
				this.header.style.transform = 'translateY(0)';
			};

			if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
				this.header.classList.remove('shopify-section-header-sticky');
				this.header.style.transform = 'translateY(0)';
				this.header.style.transition = 'background var(--duration-short)';
				if (this.header.classList.contains('color-background-1')) {
					this.header.classList.add('color-background-2');
				};
			};

			if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			if (this.preventHide) return;
			requestAnimationFrame(this.hide.bind(this));
			} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			if (!this.preventReveal) {
			requestAnimationFrame(this.reveal.bind(this));
			}else {
			window.clearTimeout(this.isScrolling);

			this.isScrolling = setTimeout(() => {
			this.preventReveal = false;
			}, 66);

			requestAnimationFrame(this.hide.bind(this));
			}
			} else if (scrollTop <= this.headerBounds.top) {
			requestAnimationFrame(this.reset.bind(this));
			}

			this.currentScrollTop = scrollTop;
		}

		hide() {
			if (this.headerIsAlwaysSticky) return;

			if (document.querySelector(".search-modal.active")) return;
			if (document.querySelector(".burger-drawer.active")) {
				this.header.classList.remove('shopify-section-header-hidden', 'animate');
			};
			if (document.querySelector(".burger-drawer.active")) return;
			if (this.headerIsAlwaysSticky) return;
			this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
			this.closeMenuDisclosure();
			if (this.headerOverlay) {
				this.headerOverlay.classList.add('color-background-1');
			}
		}

		reveal() {
			if (this.headerIsAlwaysSticky) return;
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-hidden');
			if (this.headerOverlay) {
				this.headerOverlay.classList.add('color-background-1');
				this.headerOverlay.classList.remove('color-inverse');
			}
		}

		reset() {
			if (this.headerIsAlwaysSticky) return;
			this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
			if (this.headerOverlay) {
				this.headerOverlay.classList.remove('color-background-1');
				if (!this.classList.contains('mega-menu-open')) {
					this.headerOverlay.classList.add('color-inverse');
				}
			}
		}

		closeMenuDisclosure() {
			this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
			if (this.disclosures) {
				this.disclosures.forEach(disclosure => {
					disclosure.close(); 
				});
			}
			this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
				if (this.disclosureLists) {
					this.disclosureLists.forEach(disclosureList => {
						disclosureList.setAttribute('hidden', true); 
					});
				}
			this.disclosureButton = this.header.querySelectorAll('.disclosure__button');
			if (this.disclosureButton) {
				this.disclosureButton.forEach(disclosureButton => {
					disclosureButton.setAttribute('aria-expanded', false); 
				});
			}
		}
	}

	customElements.define('sticky-header', StickyHeader);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
class CanvasCartPage extends HTMLElement {
  connectedCallback() {
    this.pending = new Map();
    this.addEventListener('input', (event) => this.queue(event));
    this.addEventListener('change', (event) => this.queue(event));
    this.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' && event.target.matches('input[data-key]')) {
        event.preventDefault();
        this.queue(event, true);
      }
    });
    this.addEventListener('click', (event) => {
      const remove = event.target.closest('[data-remove]');
      if (!remove) return;
      event.preventDefault();
      if (this.busy) return;
      this.pending.set(remove.dataset.remove, 0);
      this.flush();
    });
    if (typeof subscribe === 'function') {
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        if (!this.busy) this.refresh();
      });
    }
  }
  disconnectedCallback() {
    clearTimeout(this.timer);
    this.unsubscribe?.();
  }
  queue(event, immediately = false) {
    const input = event.target;
    if (!input.matches('input[data-key]') || this.busy) return;
    clearTimeout(this.timer);
    if (!input.checkValidity() || input.value === '') return;
    const value = Number(input.value);
    if (value === Number(input.defaultValue)) this.pending.delete(input.dataset.key);
    else this.pending.set(input.dataset.key, value);
    const checkout = this.querySelector('[name="checkout"]');
    if (checkout) checkout.disabled = this.pending.size > 0;
    if (this.pending.size) this.timer = setTimeout(() => this.flush(), immediately ? 0 : 500);
  }
  async refresh() {
    const url = new URL(window.location.href);
    url.searchParams.set('section_id', this.dataset.section);
    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error();
      this.render(await response.text());
    } catch {
      this.showError(window.cartStrings?.error || this.dataset.error);
    }
  }
  render(html) {
    const page = new DOMParser().parseFromString(html, 'text/html').querySelector('canvas-cart-page');
    if (!page) throw new Error();
    this.innerHTML = page.innerHTML;
  }
  showError(message) {
    this.querySelector('.canvas-cart-page__error').textContent = message;
  }
  async flush() {
    clearTimeout(this.timer);
    if (this.busy || !this.pending.size) return;
    this.busy = true;
    const activeId = document.activeElement?.id;
    const note = this.querySelector('[name="note"]')?.value;
    this.setAttribute('aria-busy', 'true');
    this.querySelectorAll('input,button').forEach((element) => { element.disabled = true; });
    let state;
    let error;
    try {
      for (const [id, quantity] of this.pending) {
        state = await window.CBFrameCart.change({id,quantity,sections:[this.dataset.section,'cart-drawer','cart-icon-bubble'],sections_url:window.location.pathname});
      }
      this.render(state.sections[this.dataset.section]);
      const header = document.getElementById('cart-icon-bubble');
      if (header && state.sections['cart-icon-bubble']) header.innerHTML = state.sections['cart-icon-bubble'];
      const drawer = document.querySelector('cart-drawer');
      const parsedDrawer = new DOMParser().parseFromString(state.sections['cart-drawer'] || '', 'text/html').querySelector('#CartDrawer');
      if (drawer && parsedDrawer) {
        drawer.classList.toggle('is-empty', state.item_count === 0);
        drawer.querySelector('#CartDrawer').innerHTML = parsedDrawer.innerHTML;
        drawer.querySelector('#CartDrawer-Overlay')?.addEventListener('click', () => drawer.close());
      }
      document.dispatchEvent(new CustomEvent('cart:change',{detail:{cart:state,sectionId:this.dataset.section}}));
      this.querySelector('.canvas-cart-page__status').textContent = this.querySelector('h1').textContent;
    } catch (e) {
      error = e.message || window.cartStrings?.error || this.dataset.error;
      await this.refresh();
    } finally {
      this.pending.clear();
      this.busy = false;
      this.removeAttribute('aria-busy');
      this.querySelectorAll('input,button').forEach((element) => { element.disabled = false; });
      if (note !== undefined && this.querySelector('[name="note"]')) this.querySelector('[name="note"]').value = note;
      if (error) this.showError(error);
      if (activeId) this.querySelector('#' + CSS.escape(activeId))?.focus({preventScroll:true});
    }
  }
}
if (!customElements.get('canvas-cart-page')) customElements.define('canvas-cart-page',CanvasCartPage);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  window.addEventListener('DOMContentLoaded', () => {
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.zoomButton = this.querySelector('.cb-lightbox__zoom');
        this.zoomButton?.addEventListener('click', () => {
          if (!this.gallery || this.gallery.destroyed) return;
          if (this.gallery.zoom.scale > 1) this.gallery.zoom.out();
          else this.gallery.zoom.in();
        });
        this.handleGalleryKey = (event) => {
          if (!this.hasAttribute('open') || !this.gallery) return;
          if (event.key === 'Escape') {
            event.preventDefault();
            event.stopPropagation();
            this.hide();
            return;
          }
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.gallery.zoom.out();
            if (event.key === 'ArrowRight') this.gallery.slideNext();
            else this.gallery.slidePrev();
          }
        };
      }

      hide() {
        document.removeEventListener('keydown', this.handleGalleryKey);
        if (this.gallery && !this.gallery.destroyed) {
          this.gallery.zoom.out();
          this.gallery.destroy(true, true);
        }
        this.gallery = null;
        super.hide();
        window.pauseAllMedia();
      }

      show(opener) {
        super.show(opener);
        this.createGallery();
        document.addEventListener('keydown', this.handleGalleryKey);
        this.querySelector('[id^="ModalClose-"]')?.focus({ preventScroll: true });
      }

      updateControls(scale) {
        const gallery = this.gallery;
        if (!gallery || gallery.destroyed) return;
        this.querySelector('[data-cb-image-current]').textContent = gallery.activeIndex + 1;
        this.querySelector('[data-cb-image-total]').textContent = gallery.slides.length;
        const image = gallery.slides[gallery.activeIndex]?.querySelector('.swiper-zoom-container > img');
        const zoomed = (scale ?? gallery.zoom.scale) > 1;
        this.zoomButton.hidden = !image;
        this.zoomButton.setAttribute('aria-pressed', String(zoomed));
        this.zoomButton.querySelector('span').textContent = zoomed ? this.zoomButton.dataset.zoomOut : this.zoomButton.dataset.zoomIn;
        this.classList.toggle('cb-lightbox--zoomed', zoomed);
        this.querySelector('.cb-lightbox__hint').hidden = !image;
      }

      createGallery() {
        if (this.gallery && !this.gallery.destroyed) this.gallery.destroy(true, true);
        const container = this.querySelector('#product-page-swiper');
        const slides = Array.from(container.querySelectorAll('.swiper-slide'));
        const mediaId = this.openedBy?.getAttribute('data-media-id');
        const initialSlide = Math.max(0, slides.findIndex(slide => slide.dataset.mediaId === mediaId));
        const next = this.querySelector('.swiper-button-next-prod-page');
        const previous = this.querySelector('.swiper-button-prev-prod-page');
        this.gallery = new Swiper(container, {
          zoom: { maxRatio: 3, minRatio: 1, toggle: true },
          slidesPerView: 1,
          initialSlide,
          autoHeight: false,
          speed: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 240,
          navigation: { nextEl: next, prevEl: previous },
          a11y: {
            nextSlideMessage: next?.getAttribute('aria-label'),
            prevSlideMessage: previous?.getAttribute('aria-label'),
          },
          on: {
            slideChange: () => { window.pauseAllMedia(); this.updateControls(); },
            zoomChange: (_swiper, scale) => this.updateControls(scale),
          },
        });
        this.updateControls();
      }
    }

    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();

        const handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);

          fetch(this.dataset.url)
            .then((response) => response.text())
            .then((text) => {
              const html = document.createElement('div');
              html.innerHTML = text;
              const recommendations = html.querySelector('product-recommendations--single');
              if (recommendations && recommendations.innerHTML.trim().length) {
                this.innerHTML = recommendations.innerHTML;
              }
            })
            .catch((e) => {
              console.error(e);
            });
        };

        new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
      }
    }

    customElements.define('product-modal', ProductModal);
    customElements.define('product-recommendations--single', ProductRecommendations);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            var swiper = new Swiper('.swiper-container', {
              slidesPerView: 1,

              spaceBetween: 1,
              navigation: {
                nextEl: '.product-button-group .swiper-button-next-1',
                prevEl: '.product-button-group .swiper-button-prev-1',
              },
              pagination: {
                el: '.product-card-pagination',
                clickable: true,
              },
            });
            const initAnimated = () => {
              const blocks = document.querySelectorAll('.animated-block:not(.visible)');

              const observer = new IntersectionObserver(
                (entries) => {
                  entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                      const block = entry.target;
                      block.classList.add('visible');
                      observer.unobserve(block);
                    }
                  });
                },
                { threshold: 0.1 }
              );

              blocks.forEach((block) => {
                observer.observe(block);
              });
            };
            initAnimated();
            const cursorProgress = (productSwiper) => {
              const cursor = productSwiper.querySelector('.product__cursor');
              const cursorIcon = productSwiper.querySelector('#cursor-icon1');

              const animateCursor = (e) => {
                const contentRect = productSwiper.getBoundingClientRect();
                const x = e.clientX - contentRect.left - 12;
                const y = e.clientY - contentRect.top - 12;

                cursor.animate({ transform: `translate(${x}px, ${y}px)` }, { duration: 300, fill: 'forwards' });
              };

              const getCursorClass = (position, width) => {
                return position < width / 2 ? 'prev' : 'next';
              };

              productSwiper.addEventListener('mousemove', (e) => {
                if (!e.target.closest('.link') && !e.target.closest('.swiper-pagination')) {
                  cursor.classList.add('active');
                } else {
                  cursor.classList.remove('active');
                }

                animateCursor(e);

                const position = e.clientX - productSwiper.getBoundingClientRect().left;
                cursor.dataset.type = getCursorClass(position, productSwiper.clientWidth);

                cursorIcon.className = cursor.dataset.type;
              });

              productSwiper.addEventListener('mouseleave', () => {
                cursor.classList.remove('active');
              });
            };

            const productCards = document.querySelectorAll('.card--product_cursor');
            productCards.forEach((productCard) => cursorProgress(productCard));
            const buttonHoverEffects = () => {
              if (window.innerWidth < 1200) return;
              function wrapLetters(element) {
                const text = element.textContent.trim();
                element.innerHTML = '';

                const wrapperSpan = document.createElement('span');
                wrapperSpan.className = 'wrapper';

                Array.from(text).forEach((char, charIndex) => {
                  const charSpan = document.createElement('span');
                  charSpan.className = 'char';
                  charSpan.textContent = char;
                  charSpan.style.setProperty('--char-index', charIndex + 1);
                  wrapperSpan.appendChild(charSpan);
                });

                element.appendChild(wrapperSpan);
              }

              document.querySelectorAll("[hoverstagger='text']").forEach(wrapLetters);
            };

            buttonHoverEffects();
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: '0px 0px 200px 0px',
      }).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
